<template>
    <div class=" flex flex-col items-center justify-center h-screen">
        <div v-if="error.statusCode === 404" class="text-center">
            <h1 class="text-4xl font-bold">404</h1>
            <p class="text-lg">Page not found</p>
            <p class="text-lg">Sorry about that.</p>
        </div>
        <div class="text-center">
            
            <a @click="handleError" class="text-primary">Go back to home</a>
        </div>
    </div>
</template>

<script setup>
const error = useError();
const handleError = () => {
    clearError({
        redirect: '/'
    });
}
</script>